import React, { createContext, useContext } from 'react';

/** 透传属性上下文 */
interface IInjectionContextValue {
  /** 自定义属性，可根据需要扩展 */
  taskId?: number;
  dataType: 'new' | 'legacy';
  wholeGameInfo: any;
  gameInfo: any;
  setLoading: (value: boolean) => void;
  versionId?: number;
  isTopicAnalysis?: boolean;
  originalShortUrl?: string;
  isSubscription?: boolean;
  replaceParams?: any;
  successTagged?: boolean;
  title?: string;
  isPreviews?: boolean;
  /** 隐藏筛选器底部操作按钮（确定 / 重置 / Stop），用于只读内嵌场景 */
  hideFilterOperateBtn?: boolean;
  /** 全部预览模式，预览模式下筛选器会有特殊样式调整（FilterBox: dbo-filterbox--all-preview） */
  allPreview?: boolean;
}

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const InjectionContext = createContext<IInjectionContextValue>({} as IInjectionContextValue);

/** 注入 Provider */
export function InjectionProvider({
  children,
  contextValue,
}: {
  children: React.ReactNode;
  contextValue: IInjectionContextValue;
}) {
  return (
    <InjectionContext.Provider value={contextValue}>
      {children}
    </InjectionContext.Provider>
  );
}

/** 使用注入上下文的 Hook */
export function useInjectionContext() {
  return useContext(InjectionContext);
}
